/**
 * Reducers zijn de acties die uitgevoerd worden indien er een state verandering getriggerd wordt.
 * Deze functies zullen er voor zorgen dat de states overschreven worden.
 */

export const FETCH_DATA_ERROR         = 'FETCH_DATA_ERROR';
export const FETCH_DATA_PENDING       = 'FETCH_DATA_PENDING';
export const FETCH_FACETS_SUCCESS     = 'FETCH_FACETS_SUCCESS';
export const FETCH_TEASERS_SUCCESS    = 'FETCH_TEASERS_SUCCESS';
export const FETCH_PAGINATION_SUCCESS = 'FETCH_PAGINATION_SUCCESS';

export const FILTER_BY_CATEGORY = 'FILTER_BY_CATEGORY';
export const FILTER_BY_TOOL = 'FILTER_BY_TOOL';
export const FILTER_BY_PAGE     = 'FILTER_BY_PAGE';
export const FILTER_BY_VALUE    = 'FILTER_BY_VALUE';

export const QUERY_VALUE    = 'QUERY_VALUE';
export const ORDER_BY    = 'ORDER_BY';

export const FACET_FILTERS  = 'FACET_FILTERS';
 
export function fetchDataError ( error ) {
	return {
		type: FETCH_DATA_ERROR,
		payload: error
	}
} 

export function fetchDataPending () {
	return {
		type: FETCH_DATA_PENDING,
	}
}

export function fetchFacetsSuccess ( categories, tools ) {
	return {
		type: FETCH_FACETS_SUCCESS,
		payload: {
			'categories': categories,
			'tools': tools,
		}
	}
}

/**
 * Set Description.
 */

export function fetchPaginationSuccess ( totalResults, currentPage, totalPages ) {
	return {
		type: FETCH_PAGINATION_SUCCESS,
		payload: {
			'totalResults': totalResults,
			'currentPage': currentPage,
			'totalPages': totalPages,
		}
	}
}

export function fetchTeasersSuccess ( teasers ) {
	return {
		type: FETCH_TEASERS_SUCCESS,
		payload: teasers
	}
}

/**
 * ACTIVE FILTERS
 */
export function filterByCategory ( data ) {
	return {
		type: FILTER_BY_CATEGORY,
		payload: data,
	}
}

export function filterByTool ( data ) {
	return {
		type: FILTER_BY_TOOL,
		payload: data,
	}
}

export function filterByPage ( data ) {
	return {
		type: FILTER_BY_PAGE,
		payload: data,
	}
}

export function filterByValue ( data ) {
	return {
		type: FILTER_BY_VALUE,
		payload: data, 
	}
}

export function orderBy ( data ) {
	return {
		type: ORDER_BY,
		payload: data, 
	}
}

/**
 * Query value wordt ook apart opgeslagen indien er gezocht wordt
 * met een aparte click knop (dus niet met onchange event).
 */
export function setQueryValue ( data ) {
	return {
		type: QUERY_VALUE,
		payload: data,
	}
}

/**
 * Toggle facet filters
 */
export function showFacetFilters ( data ) {
	return {
		type: FACET_FILTERS,
		payload: data,
	}
}
